/**
 * Converts a Blob object to a data URL string.
 *
 * @param data - The Blob object to convert.
 * @returns A Promise that resolves with the data URL string.
 */
export const toDataURL = (data: Blob): Promise<string> =>
  new Promise(
    (resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          const dataURL = reader.result as string;
          const index = dataURL.indexOf(";");
          if (dataURL.startsWith("; charset=utf-8", index)) {
            resolve(`${dataURL.slice(0, index)}${dataURL.slice(index + 15)}`);
          } else {
            resolve(dataURL);
          }
        },
      );
      reader.addEventListener("error", () => reject(reader.error));
      reader.readAsDataURL(data);
    },
  );

// denoCacheMetadata={"headers":{"content-type":"text/plain; charset=utf-8","expires":"Fri, 08 Nov 2024 10:15:00 GMT","x-served-by":"cache-iad-kcgs7200100-IAD","x-timer":"S1731060601.757488,VS0,VE1","x-fastly-request-id":"8e8fd95d77314bed29ec29af5b36b638607a5eeb","x-xss-protection":"1; mode=block","x-github-request-id":"AD8E:209E2C:124F42E:1409905:672DDE04","etag":"W/\"ffb8f3877d2d9d2c5d093d7fdf6655c6c3fccbabe47fac5b090450f9acb7cf2d\"","strict-transport-security":"max-age=31536000","cache-control":"max-age=300","accept-ranges":"bytes","vary":"Authorization,Accept-Encoding,Origin","source-age":"90","x-frame-options":"deny","x-cache":"HIT","x-content-type-options":"nosniff","access-control-allow-origin":"*","via":"1.1 varnish","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","date":"Fri, 08 Nov 2024 10:10:00 GMT","x-cache-hits":"0","cross-origin-resource-policy":"cross-origin"},"url":"https://raw.githubusercontent.com/takker99/ScrapJupyter/v1.7.4/toDataURL.ts","time":1731060600}